import { Link } from "react-router-dom";
import { ArrowRight, Star } from "lucide-react";
import PageHero from "@/components/PageHero";
import { Chapter } from "@/components/Chapter";
import { Reveal } from "@/components/Reveal";
import SloganMarquee from "@/components/SloganMarquee";
import { BIO_HIGHLIGHTS } from "@/lib/data";

const MeetDave = () => (
  <main data-testid="meet-dave-page">
    <PageHero
      kicker="Meet the Candidate"
      lines={["Soldier.", "Executive.", "Neighbor."]}
      intro="Dave Graham has served his country, led in the boardroom, and worked America's highways. Now he's ready to serve Delaware as its Attorney General."
    />

    <section className="bg-cream py-16 sm:py-24 md:py-28" data-testid="meet-dave-story">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <Reveal>
              <div className="relative max-w-md">
                <div className="absolute -top-4 -right-4 bottom-10 left-10 border-2 border-crimson rounded-xl" aria-hidden="true" />
                <img
                  src="/assets/dave-portrait.png"
                  alt="Dave Graham, candidate for Delaware Attorney General"
                  className="relative w-full rounded-xl shadow-xl"
                  data-testid="meet-dave-photo"
                />
                <div className="absolute -bottom-5 left-1/2 -translate-x-1/2 bg-crimson text-white font-display font-extrabold uppercase tracking-wider text-base sm:text-lg px-6 py-2.5 rounded-full shadow-lg whitespace-nowrap" data-testid="meet-dave-veteran-badge">
                  U.S. Army Veteran
                </div>
              </div>
            </Reveal>
            <Reveal delay={0.15} className="mt-10 max-w-md">
              <blockquote className="border-l-4 border-gold pl-5">
                <p className="font-editorial font-semibold text-navy text-lg sm:text-xl leading-relaxed">
                  "Delaware deserves an Attorney General who answers to the people — not to Dover insiders."
                </p>
                <cite className="not-italic font-mono text-xs uppercase tracking-[0.25em] text-crimson mt-3 block">— Dave Graham</cite>
              </blockquote>
            </Reveal>
          </div>

          <div className="lg:col-span-7 space-y-12">
            {BIO_HIGHLIGHTS.map((b, i) => (
              <Reveal key={b.title} delay={0.05 * i}>
                <article className="relative pl-8 sm:pl-12" data-testid={`bio-chapter-${i}`}>
                  <span className="absolute left-0 top-1 font-display font-black text-4xl sm:text-5xl text-crimson/20 leading-none select-none">
                    0{i + 1}
                  </span>
                  <span className="inline-block font-mono text-[11px] tracking-[0.28em] uppercase text-crimson border border-crimson/30 rounded-full px-3 py-1 mb-3">
                    {b.badge}
                  </span>
                  <h2 className="font-display font-extrabold uppercase tracking-tight text-3xl sm:text-4xl text-navy leading-none mb-4">
                    {b.title}
                  </h2>
                  <p className="text-navy/75 text-base sm:text-lg leading-relaxed max-w-2xl">{b.detail}</p>
                </article>
              </Reveal>
            ))}


          </div>
        </div>
      </div>
    </section>

    <SloganMarquee />

    <section className="bg-navy py-16 sm:py-24" data-testid="meet-dave-cta">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <Reveal>
          <Star className="w-8 h-8 text-gold fill-gold mx-auto mb-6" />
          <h2 className="font-display font-black uppercase tracking-tight text-cream text-4xl sm:text-5xl leading-none mb-6">
            Stand with Dave
          </h2>
          <p className="text-cream/70 text-base sm:text-lg max-w-xl mx-auto mb-9">
            This campaign is powered by Delawareans who believe in justice, integrity, and accountability. Chip in or lend a hand today.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/contribute" data-testid="meet-dave-contribute-button" className="inline-flex items-center gap-2 bg-crimson hover:bg-crimson-dark text-white font-display font-extrabold uppercase tracking-wider text-xl px-9 py-4 rounded-full transition-all duration-200 hover:scale-105 min-h-[56px]">
              Contribute <ArrowRight className="w-5 h-5" />
            </Link>
            <Link to="/get-involved" data-testid="meet-dave-volunteer-button" className="inline-flex items-center gap-2 border-2 border-cream/40 hover:border-cream text-cream font-display font-extrabold uppercase tracking-wider text-xl px-9 py-4 rounded-full transition-colors duration-200 min-h-[56px]">
              Get Involved
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  </main>
);

export default MeetDave;
